import { combineReducers, Reducer } from 'redux';
import { UPDATE_CURRENT_PATH } from '../actions/root.actions';
import {
	IRootStateType,
	IActionBase,
	IStateType,
} from '../models/root.interface';
import logsReducer from './logs.reducer';
import reportsReducer from './reports.reducer';
import templatesReducer from './templates.reducer';
import flowReducer from './flow.reducer';
import templatePageReducer from './templatePage.reducer';
import logPageReducer from './logPage.reducer';
import flowPageReducer from './flowPage.reducer';
import senderReducer from './sender.reducer';
import summaryReducer from './summary.reducer';
import balanceReducer from './balance.reducer';
import profileReducer from './profile.reducer';
import keyReducer from './key.reducer';
import MailTemplatesReducer from './MailTemplates.reducer';
import SMSTemplatesReducer from './SMSTemplates.reducer';
import campaignsReducer from './campaigns.reducer';
import campaignPageReducer from './campaignPage.reducer';
import ContactReducer from './contacts.reducer';
import BatchReducer from './batch.reducer';
import CountryReducer from './country.reducer';
import VoiceCampaignPageReducer from './voiceCampaignPage.reducer';
import retriesReducer from './retry.reducer';
import speechRateReducer from './speechRate.reducer';
import langReducer from './language.reducer';
import usersReducer from './users.reducer';
import chatReducer from './chat.reducer';
import voiceTemplatesReducer from './voiceTemplates.reducer';
import fbFlowReducer from './flowBuilderFlows.reducer';
import fbTemplateReducer from './flowBuilderTemplates.reducer';
import sendersListReducer from './sendersList.reducer';
import SmsTemplatesListReducer from './smsTemplatesList.reducer';
import verifyTemplatesReducer from './verifyTemplates.reducer';
import SettingsReducer from './settings.reducer';
import OPTSettingListReducer from './OPTSetting.reducer';
import chatbotReducer, { docUploadReducer } from './chatbot.reducer';
import chatbotLanguageReducer from './chatbotLanguages.reducer';
import chatbotTypeReducer from './chatbotTypes.reducer';
import rbmReducer from './rbm.reducer';
import countryReducer from './countryR.reducer';
import pricingReducer from './pricing.reducer';
import channelsReducer from './channels.reducer';
import whatsappDemoReducer from './whatsappDemo.reducer';
import waNumbersReducer from './waNumbers.reducer';
import allServicesCountries from './allServicesCountry.reducer';
import whatsappPlansReducer from './whatsappPlans.reducer';
import whatsappSupportedCountriesReducer from './whatsappSupportedCountries.reducer';
import deductionReducer from './deduction.reducer';
import verifyLogs from './verifyLogs.reducer';
import identifiersListReducer from './identifiers.reducer';
import { key as ObjectsKey, reducer as ObjectsReducer } from '../Objects';
import { key as ObjectKey, reducer as ObjectReducer } from '../Object';
import { key as ModalsKey, reducer as ModalsReducer } from '../modals';
import soundManagerReducer from './soundManager.reducer';
import addEditSoundReducer from './addEditSound.reducer';
import manageNumbersReducer from '../reducers/manageNumbers.reducer';
import unsubscribeNumberReducer from '../reducers/unsubscribeNumber.reducer';
import numberSupportedCountriesReducer from '../reducers/numbersSupportedCountries.reducer';
import { key as SideBarKey, reducer as SideBarReducer } from '../sidebar';
import { key as LoginKey, reducer as LoginReducer } from '../login';
import soundTypesReducer from './soundTypes.reducer';
import onboardingReducer from './onboarding.reducer';
import callLogsReducer from './callLogs.reducer';
import callLogsIdsReducer from './callLogsIds.reducer';
import reportCreateReducer from './reportCreate.reducer';
import analyticsReportReducer from './analyticsReport.reducer';
import {
	bridgeNumberReducer,
	activeBridgeNumberReducer,
} from './bridgeNumbers.reducer';
import callRecordsReducer from './callRecordings.reducer';
import reportFieldListsReducer from './logsMuliselectDefaultOptions.reducer';
import speechReportFieldListsReducer from './speechLogsMuliselectDefaultOptions.reducer';
import subscribeNumberReducer from './subscribeNumber.reducer';
import {
	capabilityListReducer,
	numberTypeReducer,
} from './capabilityList.reducer';
import {
	numberSubscriptionStatusReducer,
	numberSubscriptionSubStatusReducer,
	docTypeMappingReducer,
	docResubmitReducer,
} from './numberSubscriptionStatus.reducer';
import documentListReducer from './documentList.reducer';
import numberLocationsReducer from './numberLocations.reducer';
import renewNumberReducer from './renewNumber.reducer';
import {
	C2CModalReducer,
	C2CCallReducer,
	C2CGlobalOptionReducer,
} from './C2CModal.reducer';
import DownloadReducer from './download.reducer';
import smsSenderIdReducer from './smsSenderId.reducer';
import smsLogsReducer from './smsLogs.reducer';
import DashboardReducer from './dashboard.reducer';
import smsReportReducer from './smsReport.reducer';
import whatsappNumbersReducer from './whatsappNumbers.reducer';
import whatsappTemplateReducer from './whatsappTemplate.reducer';
import whatsappReportsReducer from './whatsappReports.reducer';
import whatsappLogsReducer from './whatsappLogs.reducer';
import smsVerifiedSMSReducer from './smsVerifiedSMS.reducer';
import whatsappSandboxReducer from './whatsappSandbox.reducer';
import { waPricingPlanReducer } from './waPricingPlan.reducer';
import receiveMessageReducer from './receiveMessage.reducer';
import urlShortenerReducer from './urlShortener.reducer';
import waBillingReportMonthsReducer from './waBillingReportMonths.reducer';
import waBillingReportFileReducer from './waBillingReportFile.reducer';
import failoverReducer from './failover.reducer';
import {
	callbacksListReducer,
	voiceSettingsReducer,
	clickToCallSettingsReducer,
	timeoutProfilesReducer,
} from './callbacksList.reducer';
import wabaIdDropdownReducer from './wabaIdDropDown.reducer';
import whatsappLaunchReducer from './whatsappLaunch.reducer';
import toggleViewReducer from './toggleView.reducer';
import chatbotViewReducer from './chatbotView.reducer';
import emailLogsReducer from './emailLogs.reducer';
import emailTemplatesReducer from './emailTemplates.reducer';
import chatbotCustomCodeViewReducer from './chatbotCustomCodeView.reducer';
import whatsappDeductionReducer from './whatsappDeduction.reducer';
import kdsPageReducer from './kdsPage.reducer';
import emailReportReducer from './emailReport.reducer';
import emailStatusReducer from './emailStatus.reducer';

const getCurrentTitle = () => {
	let currentRoute = window.location.pathname.substring(1).replace('_', ' ');
	let str = currentRoute.split('/');
	let finalOut = str[0].charAt(0).toUpperCase() + str[0].slice(1);
	if (finalOut === 'Flowbuilder') {
		finalOut = 'Flow builder';
	}
	return finalOut;
};

const initialState: IRootStateType = {
	page: { area: getCurrentTitle() },
};

function rootReducer(
	state: IRootStateType = initialState,
	action: IActionBase
): IRootStateType {
	switch (action.type) {
		case UPDATE_CURRENT_PATH:
			return { ...state, page: { area: action.area } };
		default:
			return state;
	}
}

const rootReducers: Reducer<IStateType> = combineReducers({
	root: rootReducer,
	logs: logsReducer,
	reports: reportsReducer,
	templates: templatesReducer,
	flow: flowReducer,
	templatePage: templatePageReducer,
	logsPage: logPageReducer,
	flowPage: flowPageReducer,
	sender: senderReducer,
	summary: summaryReducer,
	balance: balanceReducer,
	profile: profileReducer,
	key: keyReducer,
	campaigns: campaignsReducer,
	campaignPage: campaignPageReducer,
	MailTemplates: MailTemplatesReducer,
	SMSTemplates: SMSTemplatesReducer,
	voiceTemplates: voiceTemplatesReducer,
	contact: ContactReducer,
	batch: BatchReducer,
	country: CountryReducer,
	voiceCampaignPage: VoiceCampaignPageReducer,
	speechRate: speechRateReducer,
	language: langReducer,
	retries: retriesReducer,
	users: usersReducer,
	chat: chatReducer,
	fbFlows: fbFlowReducer,
	fbTemplates: fbTemplateReducer,
	sendersList: sendersListReducer,
	SmsTemplatesList: SmsTemplatesListReducer,
	verifyTemplates: verifyTemplatesReducer,
	verifyConfigurations: SettingsReducer,
	OPTSettingList: OPTSettingListReducer,
	botDetails: chatbotReducer,
	botLanguages: chatbotLanguageReducer,
	botTypes: chatbotTypeReducer,
	countryReducer: countryReducer,
	pricingReducer: pricingReducer,
	channelsReducer: channelsReducer,
	whatsappDemoReducer: whatsappDemoReducer,
	rbmDetails: rbmReducer,
	waNumbersReducer: waNumbersReducer,
	allServicesCountries: allServicesCountries,
	whatsappPlans: whatsappPlansReducer,
	whatsappSupportedCountries: whatsappSupportedCountriesReducer,
	deduction: deductionReducer,
	verifyLogs: verifyLogs,
	identifiers: identifiersListReducer,
	onboardingReducer: onboardingReducer,
	[ObjectsKey]: ObjectsReducer,
	[ObjectKey]: ObjectReducer,
	[ModalsKey]: ModalsReducer,
	soundManager: soundManagerReducer,
	addEditSound: addEditSoundReducer,
	manageNumbers: manageNumbersReducer,
	unsubscribeNumber: unsubscribeNumberReducer,
	numberSupportedCountries: numberSupportedCountriesReducer,
	[SideBarKey]: SideBarReducer,
	[LoginKey]: LoginReducer,
	soundTypes: soundTypesReducer,
	callLogsReducer: callLogsReducer,
	callLogsIdsReducer: callLogsIdsReducer,
	reportCreateReducer: reportCreateReducer,
	analyticsReportReducer: analyticsReportReducer,
	bridgeNumbers: bridgeNumberReducer,
	callRecords: callRecordsReducer,
	reportFieldsList: reportFieldListsReducer,
	speechReportFieldsList: speechReportFieldListsReducer,
	capabilityList: capabilityListReducer,
	numberSubscriptionStatus: numberSubscriptionStatusReducer,
	numberSubscriptionSubStatus: numberSubscriptionSubStatusReducer,
	documentList: documentListReducer,
	numberType: numberTypeReducer,
	subscribeNumber: subscribeNumberReducer,
	docTypeMapping: docTypeMappingReducer,
	numberLocations: numberLocationsReducer,
	docUpload: docUploadReducer,
	docResubmit: docResubmitReducer,
	renewNumber: renewNumberReducer,
	C2CModal: C2CModalReducer,
	C2CCall: C2CCallReducer,
	C2CGlobalOption: C2CGlobalOptionReducer,
	download: DownloadReducer,
	activeBridgeNumber: activeBridgeNumberReducer,
	senderId: smsSenderIdReducer,
	dashboard: DashboardReducer,
	smsReports: smsReportReducer,
	smsLogs: smsLogsReducer,
	waBillingReportMonths: waBillingReportMonthsReducer,
	waBillingReportFile: waBillingReportFileReducer,
	whatsappNumbers: whatsappNumbersReducer,
	whatsappTemplate: whatsappTemplateReducer,
	whatsappReports: whatsappReportsReducer,
	whatsappLogs: whatsappLogsReducer,
	smsVerifiedSMS: smsVerifiedSMSReducer,
	whatsappSandbox: whatsappSandboxReducer,
	waPricingPlan: waPricingPlanReducer,
	receiveMessage: receiveMessageReducer,
	urlShortener: urlShortenerReducer,
	failover: failoverReducer,
	callbacksListReducer: callbacksListReducer,
	voiceSettingsReducer: voiceSettingsReducer,
	clickToCallSettingsReducer: clickToCallSettingsReducer,
	timeoutProfilesReducer: timeoutProfilesReducer,
	wabaId: wabaIdDropdownReducer,
	whatsappLaunch: whatsappLaunchReducer,
	toggleView: toggleViewReducer,
	chatbotView: chatbotViewReducer,
	emailLogs: emailLogsReducer,
	emailTemplates: emailTemplatesReducer,
	chatbotCustomCodeView: chatbotCustomCodeViewReducer,
	whatsAppDeduction: whatsappDeductionReducer,
	kdsView: kdsPageReducer,
	emailReports : emailReportReducer,
	emailStatus : emailStatusReducer
});

export default rootReducers;
